import { render, staticRenderFns } from "./Rotation.vue?vue&type=template&id=6f778cb2&scoped=true&"
import script from "./Rotation.vue?vue&type=script&lang=js&"
export * from "./Rotation.vue?vue&type=script&lang=js&"
import style0 from "./Rotation.vue?vue&type=style&index=0&id=6f778cb2&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f778cb2",
  null
  
)

export default component.exports